import { useUpdateOrderTimberMutation } from 'API/order/OrderApi';
import { assertDefined } from 'utilities/Assertions';
import { useAppDispatch } from 'store/store';
import { loadOrderAsyncAction } from 'store/order/batchedDispatches';
import { checkForMutationSuccess } from 'API/checkForMutationSuccess';
import { IUpdateOrderPatchRequest } from '../../ui-toolkit/orders/interfaces/IUpdateOrderPatchRequest';
import { IOrderDetailsData } from '../../ui-toolkit/orders/interfaces/IOrderDetailsData';

export const useUpdateOrderTimberHook = () => {
  const [doUpdate, status] = useUpdateOrderTimberMutation();
  const dispatch = useAppDispatch();
  return {
    action: async (
      order: IOrderDetailsData,
      patchData: Partial<IUpdateOrderPatchRequest>,
      skipAddressValidation: boolean = false
    ) => {
      const orderId = order.transaction.id;
      assertDefined(orderId);
      const updateValue = await doUpdate({
        orderId,
        data: patchData,
        skipAddressValidation,
      });
      if (checkForMutationSuccess(updateValue, 'updating order')) {
        await dispatch(loadOrderAsyncAction(orderId));
      }
    },
    status,
  };
};
